// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.segmento-personalizado ion-segment-button {
  --background: #f4f4f4;
  --background-checked: #007bff;
  --color: #333;
  --color-checked: #ffffff;
  --border-radius: 8px;
  --border-color: #007bff;
  --border-style: solid;
  --border-width: 1px;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --transition: background-color 0.3s, color 0.3s;
  margin: 2px;
  min-height: 40px;
}
.segmento-personalizado ion-segment-button::part(indicator-background) {
  background: transparent;
}
.segmento-personalizado ion-segment-button.segment-button-checked {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/components/registro/registro-horas/registro-horas.component.scss"],"names":[],"mappings":"AACI;EACE,qBAAA;EACA,6BAAA;EACA,aAAA;EACA,wBAAA;EACA,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,+CAAA;EAEA,WAAA;EACA,gBAAA;AADN;AAGM;EACE,uBAAA;AADR;AAIM;EACE,iBAAA;AAFR","sourcesContent":[".segmento-personalizado {\r\n    ion-segment-button {\r\n      --background: #f4f4f4;\r\n      --background-checked: #007bff;\r\n      --color: #333;\r\n      --color-checked: #ffffff;\r\n      --border-radius: 8px;\r\n      --border-color: #007bff;\r\n      --border-style: solid;\r\n      --border-width: 1px;\r\n      --padding-top: 8px;\r\n      --padding-bottom: 8px;\r\n      --transition: background-color 0.3s, color 0.3s;\r\n\r\n      margin: 2px;\r\n      min-height: 40px;\r\n\r\n      &::part(indicator-background) {\r\n        background: transparent;\r\n      }\r\n\r\n      &.segment-button-checked {\r\n        font-weight: bold;\r\n      }\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
